import { render, staticRenderFns } from "./editCharterersTable.vue?vue&type=template&id=b1bac5b0"
import script from "./editCharterersTable.vue?vue&type=script&lang=js"
export * from "./editCharterersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports